import { render, staticRenderFns } from "./CardMealRemoveWithMacros.vue?vue&type=template&id=2180e5a1"
import script from "./CardMealRemoveWithMacros.vue?vue&type=script&lang=js"
export * from "./CardMealRemoveWithMacros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports